import Alpine from 'alpinejs';
import '../client/FirebaseClient';
import { mobileMenu } from '../alpine-data/MobileMenu';
import { getAlpineAuth } from '../alpine-data/Auth';

(window as typeof window & { Alpine: typeof Alpine }).Alpine = Alpine;

document.addEventListener('alpine:init', () => {

  mobileMenu()

  getAlpineAuth()

});

Alpine.start();

